import React from "react";
import PropTypes from "prop-types";
import { ACMG_PATHOGENICITY_COLORS } from "../../../../../../common/helpers/Constant";
import { getVUSSecondaryColorFromScore } from "../../../../../../common/helpers/helpers";
import { ColoredPill } from "../../../../../../components/atoms";
import { getAllActiveRulesStrengths } from "../../helpers";
import VerdictText from "../verdict-text";

const VerdictRenderer = ({
  localStateVerdict,
  activeOverrideStrengths,
  allRulesToggleState,
  acmgRules,
  variantClassesList,
  rulesThatMetCriteria,
}) => {
  const activeRules = getAllActiveRulesStrengths(
    activeOverrideStrengths,
    rulesThatMetCriteria
  );
  const colors = ACMG_PATHOGENICITY_COLORS;
  let color;

  const vusSecondaryColor = getVUSSecondaryColorFromScore(
    localStateVerdict.clinical_score
  );

  if (
    localStateVerdict.verdict &&
    colors[localStateVerdict.verdict.toLowerCase()]
  ) {
    color = colors[localStateVerdict.verdict.toLowerCase()];
  } else {
    // on the edge case that there is none of the above use
    // the colors from the response or default
    color =
      variantClassesList.find((vc) => vc.name === localStateVerdict.verdict)
        ?.color || "#999";
  }

  const actRules = Object.keys(activeRules)
    .map((k) => ({
      name: k,
      strength: activeRules[k],
    }))
    .filter((f) => allRulesToggleState[f.name]);

  const r = [];
  /* eslint-disable no-restricted-syntax */
  /* eslint-disable no-unused-vars */
  for (const activeRule of actRules) {
    for (const acmgRule of acmgRules) {
      // eslint-disable-next-line eqeqeq
      if (acmgRule.name == activeRule.name) {
        /*  If active rule's strength field is defined
            and its value is not the default
            (the one in the ACMG rule definitions),
            send rule name with strength as request parameter.
            */
        if (
          activeRule.strength !== null &&
          activeRule.strength !== acmgRule.strength
        ) {
          r.push(`${activeRule.name}_${activeRule.strength.replace(" ", "")}`);
        } else {
          r.push(activeRule.name);
        }
      }
    }
  }

  /* eslint-enable no-unused-vars */
  /* eslint-enable no-restricted-syntax */

  return (
    <div className="tw-flex tw-flex-col">
      <ColoredPill
        content={<VerdictText localStateVerdict={localStateVerdict} />}
        colorParams={{
          color,
          vusSecondaryColor,
        }}
      />
      {__IS_COMPONENTS_PORTAL__ && (
        <button
          type="button"
          className="btn btn-success tw-absolute tw-right-0 tw-mr-12 acmg-to-classification"
          onClick={() =>
            window.clinicalResults.classifyVariantFromComponent(
              r,
              localStateVerdict.verdict
            )
          }
        >
          Save as manual classification
        </button>
      )}
    </div>
  );
};

VerdictRenderer.propTypes = {
  acmgRules: PropTypes.arrayOf(
    PropTypes.shape({
      evidence: PropTypes.string,
      met_criteria: PropTypes.bool,
      user_explain_failed: PropTypes.arrayOf(PropTypes.string),
      acmg_triggered_strength: PropTypes.string,
      name: PropTypes.string,
    })
  ).isRequired,
  activeOverrideStrengths: PropTypes.shape({}).isRequired,
  allRulesToggleState: PropTypes.shape({}).isRequired,
  localStateVerdict: PropTypes.shape({
    benign_score: PropTypes.number,
    benign_subscore: PropTypes.string,
    clinical_score: PropTypes.number,
    pathogenic_score: PropTypes.number,
    pathogenic_subscore: PropTypes.string,
    total_score: PropTypes.number,
    verdict: PropTypes.string,
  }).isRequired,
  variantClassesList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  rulesThatMetCriteria: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

VerdictRenderer.defaultProps = {};

export default VerdictRenderer;
